import { Component, OnInit, EventEmitter, Output, Optional, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EMRService } from 'app/EMR/EMR.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
import { of } from 'rxjs';
@Component({
  selector: 'app-prescription-setting',
  templateUrl: './prescription-setting.component.html',
  styleUrls: ['./prescription-setting.component.scss']
})
export class PrescriptionSettingComponent implements OnInit {
  // @Output() public selectionChange = new EventEmitter<string>();
  selectReportValue: any;
  prescriptionSetting: any =[];

  PrintList: any =[];
  ClearList: any=[];

  constructor(public authservice: AuthService, public dialog: MatDialog, public emrservice: EMRService, public dashboardService: DashboardService, public dialogRef: MatDialogRef<PrescriptionSettingComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {

    console.log(this.data);
    this.getpreSetting(this.authservice.Loggeduser.branchid, this.authservice.Loggeduser.userid, this.data);
   
  }
  closedialog() {
    this.dialogRef.close();
  }
  pktranid: number;

  getpreSetting(bachid, userid, data){
      this.prescriptionSetting = [];
      this.PrintList =[];
      this.ClearList =[];
      this.dashboardService.subscriptions= this.emrservice.GetPreSetting(bachid, userid, data).subscribe(data => this.succesdata(data),err=>this.errordata(err))
 
  }
  succesdata(data){
    // this.emrservice.content.next('5');
      this.prescriptionSetting = data;
      if( this.prescriptionSetting.length >0){
        this.pktranid = this.prescriptionSetting[0]?.pk_TranID;
        this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
        this.ClearList = this.prescriptionSetting.filter(x => x.colName.startsWith("Clear"));
      }else{
        this.defaultdataCheck();
      }
  }
  errordata(err){
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  defaultdataCheck() {
  
    this.pktranid = 0;
    this.dashboardService.subscriptions= this.emrservice.GetPreSetting(1,1,this.data).subscribe(data => this.succesdefaultdata(data),err=>this.errordata(err));
  }
  succesdefaultdata(data){
  
    this.prescriptionSetting = data;
    this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
    this.ClearList = this.prescriptionSetting.filter(x => x.colName.startsWith("Clear"));
    console.log(this.PrintList);
    console.log( this.ClearList);
  }
  PrintListdata: any = [];
  PrintClick(clickedItem: number) {
    this.PrintListdata = [];
    this.PrintList[clickedItem].colValue = !this.PrintList[clickedItem].colValue
  
  }
  ClearClick(clickedItem: number) {
    this.ClearList[clickedItem].colValue = !this.ClearList[clickedItem].colValue

  }
  checkCLearvalue(type) {

    if (this.ClearList.length > 0) {
      let checkvlaue = this.ClearList.filter(item => item.colName == type);
      if (checkvlaue.length > 0) {
        return checkvlaue[0].colValue ? checkvlaue[0].colValue : false;
      } else {
        return false;
      }

    } else {
      return false;
    }



  }
  checkchangevalue(type) {
    if (this.PrintList.length > 0) {
      let checkvlaue = this.PrintList.filter(item => item.colName == type);
      if (checkvlaue.length > 0) {
        return checkvlaue[0].colValue ? checkvlaue[0].colValue : false;
      } else {
        return false;
      }

    } else {
      return false;
    }


  }
  PreSetting: any = [];
  SavePreSetting() {



    if (this.PrintList.length > 0) {
      let payload = {

        "OpdPrescriptionSetting":
        {
          "IsEdit": this.pktranid == 0 ? false : true,
          "PK_TranId": this.pktranid,
          "FK_BranchId": this.authservice.Loggeduser.branchid,
          "IsHeader": this.checkchangevalue('IsHeader'),
          "IsDirectPrint": this.checkchangevalue('IsDirectPrint'),
          "PrintComplaint": this.checkchangevalue('Complaints'),
          "PrintDiagnosis": this.checkchangevalue('Diagnosis'),
          "PrintFinding": this.checkchangevalue('Finding'),
          "PrintHistory": this.checkchangevalue('History'),
          "PrintGlasses": this.checkchangevalue('GlassPrescription'),
          "PrintVision": this.checkchangevalue('Vision'),
          "PrintIOP": this.checkchangevalue('PrintIOP'),
          "PK_SynchId": 0,
          "PlanofCare": this.checkchangevalue('PlanofCare'),
          "DoctorAdvice": this.checkchangevalue('DoctorAdvice'),
          "LABReport": this.checkchangevalue('LABReport'),
          "ASCAN": this.checkchangevalue('ASCAN'),
          "Diagram": this.checkchangevalue('Diagram'),
          "PrintPrognosis": this.checkchangevalue('Prognosis'),
          "PrintCounselorRemark": this.checkchangevalue('PrintRemarkForCounselor'),
          "PrintGvp": this.checkchangevalue('PrintUnderGvp'),
          "ClearFindings": this.checkCLearvalue('ClearFindings'),
          "ClearDiagnosis": this.checkCLearvalue('ClearDiagnosis'),
          "ClearSurgery": this.checkCLearvalue('ClearSurgery'),
          "ClearInvestigation": this.checkCLearvalue('ClearInvestigation'),
          "ClearPrescription": this.checkCLearvalue('ClearPrescription'),
          "PrintAutoref": this.checkchangevalue('AUTOREF'),
          "IsDrPrescriptionSignature": this.checkchangevalue('DigiSign'),
          "IsVisitDateTime": this.checkchangevalue('VisitDateWithTime'),
          "PrintOPDtests": this.checkchangevalue('PrintOPDTest'),
          "Printoptomestricname": this.checkchangevalue('Printoptomestricname'),
          "printVital": this.checkchangevalue('printVital'),
          "FK_UserID": this.authservice.Loggeduser.userid,
          "ClearPlanOfCare": this.checkCLearvalue('ClearPlanOfCare'),
          "CheckShowAllInInvestigationSelection": this.checkchangevalue('CheckShowAllInInvestigationSelection'),
          "PrintDiagnosisComments": this.checkchangevalue('PrintDiagnosisComments'),
          "PrintFindingComments": this.checkchangevalue('PrintExaminationRemarks'),
          "PrintInvestigation": this.checkchangevalue('PrintInvestigation'),
          "PrintImmunization": this.checkchangevalue('PrintImmunization'),
          "PrintCrossReferralReason": this.checkchangevalue('PrintCrossrefReason'),
          "PrintReviewNotes": this.checkchangevalue('PrintReviewNotes'),
          "PrintNutritionalAdvice": this.checkchangevalue('PrintNutritionalAdvice'),
          "PrintFootNote": this.checkchangevalue('FootNote'),
          "ReportName": this.data,
          "PrintReviewDate": this.checkchangevalue('PrintReviewDate'),
          "PrintGVPComments":this.checkchangevalue('PrintGVPRemarks'),
        }
      }
      console.log("aaaaa", payload);
      this.dashboardService.subscriptions=  this.emrservice.SavePreSettingData(payload).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.PrintListdata = [];
          this.getpreSetting(this.authservice.Loggeduser.branchid, this.authservice.Loggeduser.userid, this.data);
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          this.closedialog();
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Please select list", "OK");
    }
  }

}
